export const COUNTERS = [
    {
        count: 4,
        text: "Years<br />of Experience"
    },
    {
        count: 12,
        text: "Projects<br />Completed"
    }
]